import AvatarDefaultIcon from '@assets/images/avatar/default.png';
import BlankTabIcon from '@assets/images/common/icon/blank-tab/blank-tab.svg';
import BlankTabIconWhite from '@assets/images/common/icon/blank-tab/blank-tab-white.svg';
import { useTenantAuth } from '@src/context/auth/useTenantAuth';
import { TENANT_URL } from '@src/routes/tenant';
import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const TenantAccountMenu = ({ textColorBlack = false, isCommunityHeader = false }) => {
  const [isMenuShow, setIsMenuShow] = useState(false);
  const handleClickAccountMenu = () => {
    setIsMenuShow((prev) => !prev);
  };
  const tenantAuth = useTenantAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      if (!target.closest('[data-account-menu]')) {
        setIsMenuShow(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);
  const menuLinks = [
    {
      title: 'マイプロフィール',
      link: TENANT_URL.PROFILE,
      targetBlank: true,
    },
    {
      title: 'ログアウト',
      link: TENANT_URL.LOGOUT,
      targetBlank: false,
    },
  ];
  return (
    <div className='relative'>
      <button
        type='button'
        className={`flex w-full items-center gap-4 text-left transition-opacity hover:opacity-70 ${textColorBlack ? 'text-black' : 'text-white'}`}
        onClick={handleClickAccountMenu}
        data-account-menu
      >
        <img
          className='size-6 rounded-full bg-white object-cover'
          src={tenantAuth.profile?.user?.avatarUrl || AvatarDefaultIcon}
          alt=''
          width='24'
          height='24'
        />
        <p className='grow truncate'>
          <span className='block truncate'>{`${tenantAuth?.profile?.user?.familyName || ''} ${tenantAuth?.profile?.user?.firstName || ''}`}</span>
        </p>
        <div className='grid size-[60px] flex-[0_0_auto] place-items-center'>
          <div className='h-[5px] w-[10px] bg-current [clip-path:polygon(50%_100%,0_0,100%_0)]'></div>
        </div>
      </button>
      {isMenuShow && (
        <div
          className='absolute left-0 top-full w-full overflow-hidden rounded-md border border-gray-200 bg-white text-sm'
          data-account-menu
          style={{ zIndex: 2000 }}
        >
          <div className='flex flex-col gap-px bg-gray-200'>
            {menuLinks.map((link) =>
              isCommunityHeader && link.targetBlank ? (
                <Link
                  key={link.link}
                  to={link.link}
                  target='_blank'
                  rel='noopener noreferrer'
                  className='group flex cursor-pointer items-center gap-2 bg-white px-6 py-[15px] transition-colors hover:bg-primary-500 hover:text-white'
                >
                  {link.title}
                  <img
                    src={BlankTabIcon}
                    alt=''
                    width='16'
                    height='16'
                    className='block size-4 group-hover:hidden'
                  />
                  <img
                    src={BlankTabIconWhite}
                    alt=''
                    width='16'
                    height='16'
                    className='hidden size-4 group-hover:block'
                  />
                </Link>
              ) : (
                <div
                  key={link.link}
                  onClick={() => navigate(link.link)}
                  role='button'
                  tabIndex={0}
                  className='group flex cursor-pointer items-center gap-2 bg-white px-6 py-[15px] transition-colors hover:bg-primary-500 hover:text-white'
                >
                  {link.title}
                </div>
              )
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default TenantAccountMenu;
